
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-configurar-funcionalidades',
  templateUrl: 'configurar-funcionalidades.component.html'
})

export class ConfigurarFuncionalidadesComponent implements OnInit {
  constructor() { }

  ngOnInit() { }
}